import React, { useEffect, useState, useCallback } from "react";
import { Container, CertificateContent } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import { Button, Spin } from "antd";
import { MdFileDownload, MdFlip } from "react-icons/md";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function Certificate() {
  const { user } = useAuth();

  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);

  const listCourses = useCallback(async () => {
    try {
      const response = await api.get(`/courses-user`);
      let courses = response.data;
      if (user.courses_enabled) {
        let coursesEdit = courses.filter((item) => item.restricted);
        coursesEdit = [
          ...coursesEdit,
          ...courses.filter((item) => !item.restricted),
        ];
        setCourses(coursesEdit);
      } else {
        setCourses(courses);
      }
    } catch (error) {
      toast.error("Erro ao carregar os cursos. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }, [user.courses_enabled]);

  useEffect(() => {
    listCourses();
  }, [listCourses]);

  const generatePDF = () => {
    const front = document.getElementById("certificate-front");
    const back = document.getElementById("certificate-back");
    const pdf = new jsPDF({
      orientation: "landscape",
    });

    html2canvas(front).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      pdf.addPage();

      // Temporarily remove the transform from the back side for printing
      back.style.transform = "none";

      html2canvas(back).then((canvasBack) => {
        const imgDataBack = canvasBack.toDataURL("image/png");
        const pdfHeightBack = (canvasBack.height * pdfWidth) / canvasBack.width;
        pdf.addImage(imgDataBack, "PNG", 0, 0, pdfWidth, pdfHeightBack);
        pdf.save(`certificado-${user.name}.pdf`);

        // Restore the transform
        back.style.transform = "rotateY(180deg)";
      });
    });
  };

  const completedModules = courses.filter((module) =>
    module.courses.every((course) => {
      const totalConfirm = course.lessons.reduce(
        (acc, data) => acc + data.confirms.length,
        0,
      );
      return (
        totalConfirm === course.lessons.length && course.lessons.length > 0
      );
    }),
  );

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Certificado</h1>
        <div>
          <Button
            type="primary"
            onClick={() => setIsFlipped(!isFlipped)}
            style={{ borderRadius: 50, marginRight: 10 }}
          >
            <MdFlip size={14} />
            Virar Certificado
          </Button>
          <Button
            type="primary"
            onClick={generatePDF}
            style={{ borderRadius: 50 }}
          >
            <MdFileDownload size={14} />
            Baixar Certificado
          </Button>
        </div>
      </div>

      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <div id="certificate-container">
          <CertificateContent
            id="certificate-to-download"
            className={isFlipped ? "is-flipped" : ""}
          >
            <div id="certificate-front" className="certificate-face">
              <div className="header">
                <h1>Certificado de Conclusão</h1>
              </div>
              <div className="body">
                <p>Certificamos que</p>
                <h2>{user.name}</h2>
                <p>concluiu com sucesso o curso.</p>
              </div>
              <div className="footer">
                <p>Guruseg - {new Date().toLocaleDateString()}</p>
              </div>
            </div>
            <div
              id="certificate-back"
              className="certificate-face certificate-back"
            >
              <div className="header">
                <h1>Módulos Concluídos</h1>
              </div>
              <div className="body">
                <ul>
                  {completedModules.map((module) => (
                    <li key={module.id}>{module.name}</li>
                  ))}
                </ul>
              </div>
            </div>
          </CertificateContent>
        </div>
      )}
    </Container>
  );
}
